import { useCloudFunction } from './useCloudFunction';
import { dateToNs, nsToDate } from './timestampUtils';
import type { AccountTransfer } from '../types';

type RawTransferRow = Omit<AccountTransfer, 'timestamp' | 'amount'> & {
    timestamp: string;
    amount: number | string;
};

export function useCombinedTransfers(
    accountIds: string[],
    from: Date,
    to: Date,
    offset = 0,
): { data: AccountTransfer[]; loading: boolean; error: Error | null } {
    const params =
        accountIds.length > 0
            ? { accountIds, from: dateToNs(from), to: dateToNs(to), offset }
            : null;

    return useCloudFunction<RawTransferRow, AccountTransfer>(
        'loadAccountTransfers',
        params,
        (rows) =>
            rows.map((row) => ({
                ...row,
                amount: Number(row.amount),
                timestamp: nsToDate(row.timestamp),
            })),
    );
}
